import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { productsKeys } from "~/api/products/keys";

export const useInvalidateProducts = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (userIdentifier: string | null | undefined) => {
      if (userIdentifier) {
        queryClient.removeQueries({
          queryKey: productsKeys.listsByUserIdentifier(userIdentifier)
        });
        return;
      }

      queryClient.invalidateQueries({
        queryKey: productsKeys.lists()
      });
    },
    [queryClient]
  );
};
